/*
  <momo-autoplay-video> — KEIN Autoplay (früher: Play sobald sichtbar).
  Verhalten (identisch zu den App-Features-Videos):
    • Maus/Desktop: Video spielt nur bei Hover (mouseenter) bzw. Tastatur-Fokus über der Karte, pausiert beim Verlassen.
    • Touch/Mobil: Video spielt, sobald es ins Sichtfeld scrollt (IntersectionObserver) — aber ERST nachdem einmal
      echt getoucht wurde. Ein vorhandener Mauszeiger löst so NIEMALS Autoplay aus (unabhängig von hover/pointer-
      Media-Query-Eigenheiten mancher Touch-Displays/Trackpads).
  Muted + playsinline = Voraussetzung für programmatisches Abspielen.
*/
(function () {
  var touchSeen = false;
  var instances = [];

  /*
    Shopify liefert zu jedem Video zwei Quellen aus, die .m3u8 (HLS) ZUERST, danach das MP4.
    Der Browser nimmt die erste Quelle, die er abspielen kann. Desktop-Chrome/Firefox können kein HLS
    und landen beim MP4 — unauffällig. iOS kann HLS nativ und übergibt das Video damit an den
    System-Player: eigene Steuerleiste, Bild-in-Bild, Vollbild. Für eine stumme Deko-Schleife bringt
    adaptives Streaming nichts, also wird die HLS-Quelle vor dem ersten play() entfernt.
    Entfernt wird nur, wenn danach mindestens eine MP4-Quelle übrig bleibt.
  */
  function stripHls(video) {
    if (!video) return;
    var all = video.querySelectorAll('source');
    var hls = video.querySelectorAll('source[type="application/x-mpegURL"], source[src*=".m3u8"]');
    if (!hls.length || hls.length >= all.length) return;
    var wasPlayingHls = (video.currentSrc || '').indexOf('.m3u8') > -1;
    Array.prototype.forEach.call(hls, function (s) { s.parentNode.removeChild(s); });
    if (wasPlayingHls || !video.currentSrc) video.load(); // Quellenauswahl neu treffen
  }

  function armTouch() {
    if (touchSeen) return;
    touchSeen = true;
    document.removeEventListener('touchstart', armTouch);
    instances.forEach(function (el) { el.enableScrollPlay(); });
  }
  document.addEventListener('touchstart', armTouch, { passive: true });

  if (!customElements.get('momo-autoplay-video')) {
    customElements.define(
      'momo-autoplay-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;
          this.video.muted = true;
          this.video.setAttribute('muted', '');
          this.video.removeAttribute('autoplay');
          stripHls(this.video);

          // Hover/Fokus (Maus/Trackpad, auch Touch-Laptop MIT Maus): spielt nur solange der Cursor drüber ist.
          this._onEnter = this.play.bind(this);
          this._onLeave = this.pauseVid.bind(this);
          this.addEventListener('mouseenter', this._onEnter);
          this.addEventListener('mouseleave', this._onLeave);
          this.addEventListener('focusin', this._onEnter);
          this.addEventListener('focusout', this._onLeave);

          // Standbild: solange NICHT gespielt wird, liegt das Thumbnail über dem Video (siehe
          // .momo-skillcard__still). Der Zustand hängt an den echten Video-Events, nicht am
          // play()-Aufruf — sonst verschwände das Standbild auch dann, wenn play() abgelehnt wird.
          var host = this;
          this._onPlaying = function () { host.classList.add('is-playing'); };
          this._onStopped = function () { host.classList.remove('is-playing'); };
          this.video.addEventListener('playing', this._onPlaying);
          ['pause', 'ended', 'emptied', 'error'].forEach(function (ev) {
            host.video.addEventListener(ev, host._onStopped);
          });

          instances.push(this);
          if (touchSeen) this.enableScrollPlay();
        }

        // Touch: Play/Pause anhand Sichtbarkeit — erst nach der ersten echten Touch-Berührung aktiviert.
        enableScrollPlay() {
          if (this._observing || !this.video) return;
          this._observing = true;
          if (!('IntersectionObserver' in window)) { this.play(); return; }
          this.observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                var el = entry.target;
                if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { el.play(); } else { el.pauseVid(); }
              });
            },
            { threshold: [0, 0.5, 1] }
          );
          this.observer.observe(this);
        }

        play() {
          if (!this.video) return;
          var p = this.video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }

        pauseVid() {
          if (this.video) this.video.pause();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          var i = instances.indexOf(this);
          if (i > -1) instances.splice(i, 1);
        }
      }
    );
  }
})();
